import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar: React.FC = () => {
  const { user, logout, isAdmin, isEmprendedor } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  if (!user) {
    return null;
  }

  return (
    <nav className="bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to={isAdmin ? '/dashboard-admin' : '/dashboard-emprendedor'} className="flex items-center space-x-2">
            <div className="bg-white text-primary-600 rounded-lg px-3 py-1 font-bold text-xl">
              Zonna IN
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            {isAdmin && (
              <>
                <Link to="/dashboard-admin" className="hover:text-primary-100 transition-colors">
                  Dashboard
                </Link>
                <Link to="/admin/crear-evento" className="hover:text-primary-100 transition-colors">
                  Crear Evento
                </Link>
                <Link to="/admin/usuarios" className="hover:text-primary-100 transition-colors">
                  Usuarios
                </Link>
                <Link to="/admin/roles" className="hover:text-primary-100 transition-colors">
                  Roles
                </Link>
              </>
            )}
            {isEmprendedor && (
              <>
                <Link to="/dashboard-emprendedor" className="hover:text-primary-100 transition-colors">
                  Mi Dashboard
                </Link>
                <Link to="/eventos" className="hover:text-primary-100 transition-colors">
                  Eventos Disponibles
                </Link>
              </>
            )}
            <div className="flex items-center space-x-3">
              <span className="text-sm">
                Hola, <span className="font-semibold">{user.name}</span>
              </span>
              <button
                onClick={handleLogout}
                className="bg-white text-primary-600 px-4 py-2 rounded-lg hover:bg-primary-50 transition-colors font-medium"
              >
                Cerrar Sesión
              </button>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded-lg hover:bg-primary-500 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-primary-500">
            <div className="flex flex-col space-y-3">
              <span className="text-sm px-4 py-2">
                Hola, <span className="font-semibold">{user.name}</span>
              </span>
              {isAdmin && (
                <>
                  <Link
                    to="/dashboard-admin"
                    className="px-4 py-2 hover:bg-primary-500 transition-colors rounded"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Dashboard
                  </Link>
                  <Link
                    to="/admin/crear-evento"
                    className="px-4 py-2 hover:bg-primary-500 transition-colors rounded"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Crear Evento
                  </Link>
                  <Link
                    to="/admin/usuarios"
                    className="px-4 py-2 hover:bg-primary-500 transition-colors rounded"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Usuarios
                  </Link>
                  <Link
                    to="/admin/roles"
                    className="px-4 py-2 hover:bg-primary-500 transition-colors rounded"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Roles
                  </Link>
                </>
              )}
              {isEmprendedor && (
                <>
                  <Link
                    to="/dashboard-emprendedor"
                    className="px-4 py-2 hover:bg-primary-500 transition-colors rounded"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Mi Dashboard
                  </Link>
                  <Link
                    to="/eventos"
                    className="px-4 py-2 hover:bg-primary-500 transition-colors rounded"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Eventos Disponibles
                  </Link>
                </>
              )}
              <button
                onClick={handleLogout}
                className="mx-4 bg-white text-primary-600 px-4 py-2 rounded-lg hover:bg-primary-50 transition-colors font-medium"
              >
                Cerrar Sesión
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
